// Platform Module Types

export enum PlatformModule {
  CORE_BANKING = 'CORE_BANKING',
  ADVANCED_SECURITY = 'ADVANCED_SECURITY',
  CREDIT_ENGINE = 'CREDIT_ENGINE',
  OPEN_FINANCE = 'OPEN_FINANCE',
  CARD_ISSUING = 'CARD_ISSUING',
  INVESTMENTS = 'INVESTMENTS',
  TOKENIZATION = 'TOKENIZATION',
  BENEFITS = 'BENEFITS',
  CRYPTO = 'CRYPTO',
}

export enum PlanTier {
  BASIC = 'BASIC',
  STANDARD = 'STANDARD',
  PREMIUM = 'PREMIUM',
}

export interface ModuleDefinition {
  id: PlatformModule;
  name: string;
  description: string;
  category: string;
  icon: string;
  dependencies: PlatformModule[];
  availableInTiers: PlanTier[];
  defaultConfig: Record<string, any>;
}

export interface TenantModuleConfig {
  id: string;
  tenantId: string;
  moduleId: PlatformModule;
  isEnabled: boolean;
  config: Record<string, any>;
  activatedAt?: string;
  deactivatedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface TenantModuleStatus extends ModuleDefinition {
  isEnabled: boolean;
  config?: Record<string, any>;
  activatedAt?: string;
  deactivatedAt?: string;
}

export interface TenantModulesResponse {
  tenantId: string;
  tier: PlanTier;
  modules: TenantModuleStatus[];
}

export interface ModuleOperationResult {
  success: boolean;
  moduleId: PlatformModule;
  isEnabled: boolean;
  config?: Record<string, any>;
  message: string;
}

export interface EnableModuleDto {
  config?: Record<string, any>;
}

export interface UpdateModuleConfigDto {
  config: Record<string, any>;
}

export interface UpdateTenantTierDto {
  tier: PlanTier;
}

export interface DependencyValidation {
  valid: boolean;
  missingDependencies: PlatformModule[];
}

// Module category colors for UI
export const MODULE_CATEGORY_COLORS: Record<string, string> = {
  Banking: 'blue',
  Security: 'red',
  Credit: 'green',
  Integration: 'purple',
  Cards: 'orange',
  Investments: 'cyan',
  Blockchain: 'yellow',
  Benefits: 'pink',
  Crypto: 'amber',
};

// Tier badge colors
export const TIER_COLORS: Record<PlanTier, string> = {
  [PlanTier.BASIC]: 'gray',
  [PlanTier.STANDARD]: 'blue',
  [PlanTier.PREMIUM]: 'gold',
};

// Tier labels in Portuguese
export const TIER_LABELS: Record<PlanTier, string> = {
  [PlanTier.BASIC]: 'Básico',
  [PlanTier.STANDARD]: 'Standard',
  [PlanTier.PREMIUM]: 'Premium',
};
